// pwa/src/components/Shop.js
import React, { useContext, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import { Button, Box } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import Chat from "./Chat";

const Shop = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [shop, setShop] = useState([]);
  const [copiado, setCopiado] = useState(false);
  const getShop = () => {
    axios
      .get("/api/marketplace/tiendanube/shop")
      .then((response) => {
        setShop(response.data.shop);
        console.log("response.data: ", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getShop();
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({
            id: "app.header.shop.label",
          }),
        },
      ]);
    }
  }, []); // Se ejecuta cuando cambia la paginación o la ordenación

  const codigoInstalacion = `<script defer src="${process.env.REACT_APP_API_URL}/widget.js"></script>
<script>
  document.addEventListener('DOMContentLoaded', function() {
    if (window.initChatSenseWidget) {
      window.initChatSenseWidget({
        shopId: '${shop.id}'
      });
    } else {
      console.error('Widget not loaded properly');
    }
  });
</script>`;

  const copiarAlPortapapeles = () => {
    navigator.clipboard
      .writeText(codigoInstalacion)
      .then(() => {
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000); // Reset después de 2 segundos
      })
      .catch((err) => {
        console.error("Error al copiar: ", err);
      });
  };

  const InstruccionesWidget = () => {
    return (
      <div className="instrucciones-widget">
        <h2>Instrucciones de instalación del Widget</h2>
        <p>
          Copie y pegue el siguiente código HTML en su sitio web, justo antes
          del cierre de la etiqueta <code>&lt;/body&gt;</code>:
        </p>
        <pre className="codigo-instalacion">
          <code>
          {codigoInstalacion}
          </code>
        </pre>
      </div>
    );
  }

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            {/* <Box sx={{ width: "100%" }}>{shop.name}</Box> */}
            <Box sx={{ width: "100%" }}><img src={(shop.logo)?"https:"+shop.logo:"/assets/images/dummy.png"} alt={shop.name} /></Box>
            <Box sx={{ width: "100%" }}>
              <InstruccionesWidget />
              <Button
                variant="contained"
                color={copiado ? "success" : "primary"}
                size="small"
                startIcon={copiado ? <CheckIcon /> : <ContentCopyIcon />}
                onClick={copiarAlPortapapeles}
                className="boton-copiar-mui"
              >
                {copiado ? "¡Copiado!" : "Copiar código"}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
        </Grid>
      </Container>
      <Chat shopId={shop.id} />
    </Layout>
  );
};

export default Shop;
